<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>MarketingIcon</title>
    <g
      id="marketing-icon"
      class="override-fill"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <rect
        id="marketing-icon-rectangle"
        class="override-fill"
        fill="none"
        fill-rule="nonzero"
        stroke="none"
        x="1"
        y="1"
        width="12"
        height="12"/>
      <!-- eslint-disable max-len -->
      <path
        id="marketing-icon-triangle"
        d="M5.60995246,8.55995246 L8.74143536,8.55995246 L7.17569391,6.21134027 L5.60995246,8.55995246 Z M10.6099525,9.55995246 L3.74143536,9.55995246 L7.17569391,4.40856464 L10.6099525,9.55995246 Z"
        fill="none"
        stroke="none"
        stroke-width="0.5"
        fill-rule="nonzero"
        transform="translate(7.175694, 6.984259) rotate(-270.000000) translate(-7.175694, -6.984259) "/>
        <!-- eslint-enable max-len -->
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MarketingIcon',
}
</script>




// WEBPACK FOOTER //
// src/components/navigation/icons/MarketingIcon.vue